import { IFolder } from '@opengov/reporting-types';
import { QueryKey } from '@tanstack/react-query';
import { QUERY_CACHE_PERIOD } from '../../../../../../apiHooks/core/queryConstants';
import { useFetchQuery } from '../../../../../../apiHooks/core/rest/useFetchQuery';
import { reportsFoldersQueryKeys, ReportsFoldersQueryParams } from './reportsFolders.queryKeys';

export function useGetReportsFolders({ entityId, sort, enabled }: ReportsFoldersQueryParams & { enabled?: boolean }) {
  const queryKey: QueryKey = reportsFoldersQueryKeys.withQueryParams({ entityId, sort });
  const queryString = new URLSearchParams({
    entityId: entityId ? `${entityId}` : '',
    ...(sort ? sort : {})
  }).toString();
  const url = `/api/reporting_service/v4/folders?${queryString}`;

  return useFetchQuery<{ data: IFolder[] }>({
    queryKey,
    url,
    options: { enabled, staleTime: QUERY_CACHE_PERIOD.SHORT }
  });
}
